(function () {
  console.log("[MCStudent] flow loaded");

  function getCookie(name) {
    const m = document.cookie.match(
      new RegExp("(?:^|; )" + name.replace(/([$?*|{}()\[\]\\\/+^])/g, "\\$1") + "=([^;]*)")
    );
    return m ? decodeURIComponent(m[1]) : null;
  }

  function isStudentModeEnabled() {
    const params = new URLSearchParams(window.location.search);
    return params.get("student_mode") === "1" || getCookie("student_mode") === "1";
  }

  function isLoggedIn() {
    return (
      document.body.classList.contains("customer-logged-in") ||
      !!window.Shopify?.customer
    );
  }

  function handleIntercept(form) {
    if (!form) return;

    const formData = new FormData(form);

    const payload = {
      id: formData.get("id"),
      quantity: formData.get("quantity") || 1
    };

    // ✅ Save product
    sessionStorage.setItem(
      "mcstudent_pending_item",
      JSON.stringify(payload)
    );

    console.log("[MCStudent] Saved pending item:", payload);

    // ✅ Save return URL
    const returnTo = window.location.pathname + window.location.search;
    sessionStorage.setItem("mcstudent_return_after_login", returnTo);

    // ✅ Redirect
    window.location.href = "/account/register?student_mode=1";
  }

  // ✅ 1. Catch FORM submit
  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = (form.getAttribute("action") || "").toLowerCase();
      const isAddToCart =
        action.includes("/cart/add") || form.querySelector('[name="id"]');

      if (!isAddToCart) return;
      if (!isStudentModeEnabled()) return;
      if (isLoggedIn()) return;

      e.preventDefault();
      e.stopPropagation();

      handleIntercept(form);
    },
    true
  );

  // ✅ 2. Catch BUTTON click (THIS FIXES YOUR ISSUE)
  document.addEventListener(
    "click",
    function (e) {
      const btn = e.target.closest('button[type="submit"], [name="add"]');
      if (!btn) return;

      const form = btn.closest("form");
      if (!form) return;

      const action = (form.getAttribute("action") || "").toLowerCase();
      const isAddToCart =
        action.includes("/cart/add") || form.querySelector('[name="id"]');

      if (!isAddToCart) return;
      if (!isStudentModeEnabled()) return;
      if (isLoggedIn()) return;

      e.preventDefault();
      e.stopPropagation();

      handleIntercept(form);
    },
    true
  );
})();